__turbopack_context__.v({
  "contentArea": "AddOnsPageLayout-module-scss-module__kT-GeG__contentArea",
  "contentInner": "AddOnsPageLayout-module-scss-module__kT-GeG__contentInner",
  "filtersInline": "AddOnsPageLayout-module-scss-module__kT-GeG__filtersInline",
  "filtersSidebar": "AddOnsPageLayout-module-scss-module__kT-GeG__filtersSidebar",
  "layoutWrapper": "AddOnsPageLayout-module-scss-module__kT-GeG__layoutWrapper",
});
